<template>
  <v-app>
    <v-content class="login-form">
      <v-container>
        <v-row>
          <v-col justify-self="center">
            <div class="display-1 text-center atlas-brand primary--text">
              atlas
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            sm="6"
            offset-sm="3"
            md="4"
            offset-md="4"
            xl="2"
            offset-xl="5"
          >
            <v-card>
              <v-card-title class="justify-center">
                {{ showResetForm ? $t('auth.resetPassword') : $t('auth.signin') }}
              </v-card-title>

              <v-card-text>
                <v-alert
                  color="error"
                  :value="error"
                >
                  {{ error }}
                </v-alert>

                <div
                  v-if="showResetForm"
                  v-t="'auth.sendResetEmailInfo'"
                  class="text-center mb-4"
                />

                <v-form v-model="validForm">
                  <v-text-field
                    v-model.trim="email"
                    label="Email"
                    prepend-icon="email"
                    autofocus
                    :rules="[ required, isEmail ]"
                  />

                  <v-text-field
                    v-if="!showResetForm"
                    v-model="password"
                    label="Password"
                    prepend-icon="lock"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[ required ]"
                    @click:append="showPassword = !showPassword"
                  />
                </v-form>

                <p
                  v-show="!showResetForm"
                  class="login__forgot-password"
                >
                  <span
                    v-t="'auth.forgotPassword'"
                    @click="showResetForm = true"
                  />
                </p>

                <p
                  v-show="showResetForm"
                  class="login__forgot-password"
                >
                  <span
                    v-t="'auth.signin'"
                    @click="showResetForm = false"
                  />
                </p>
              </v-card-text>

              <v-card-actions class="px-12 py-6">
                <v-btn
                  v-show="!showResetForm"
                  v-t="'auth.signin'"
                  block
                  depressed
                  color="primary"
                  :disabled="!validForm"
                  @click="checkCreds"
                />

                <v-btn
                  v-show="showResetForm"
                  v-t="'auth.sendResetEmail'"
                  block
                  depressed
                  color="primary"
                  :disabled="!validForm"
                  @click="sendResetEmail"
                />
              </v-card-actions>

              <v-divider />

              <p
                v-t="'auth.notMember'"
                class="text-center grey--text my-2"
              />

              <v-card-actions class="px-12 pb-6">
                <v-btn
                  v-t="'auth.signup'"
                  block
                  outlined
                  :to="{ name: 'signup' }"
                />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

import { login, sendResetPasswordEmail } from '@/plugins/stitch'
import { isEmail, required } from '@/utils/rules'

export default {
  name: 'Login',
  data () {
    return {
      email: this.$route.query.e,
      password: this.$route.query.p,
      error: null,
      showPassword: false,
      showResetForm: false,
      validForm: false
    }
  },
  computed: {
    ...mapState('user', [
      'authFirstCheck'
    ])
  },
  methods: {
    isEmail,
    required,
    checkCreds () {
      login(this.email, this.password)
        .then(user => {
          this.$store.dispatch('doFirstLoad')
          this.$router.push({
            path: this.$route.query.redirect || '/'
          })
        })
        .catch(error => {
          this.error = error.message
        })
    },
    sendResetEmail () {
      sendResetPasswordEmail(this.email)
        .then(() => {
          this.$notify('We sent you an email with instructions')
        })
        .catch()
    }
  }
}
</script>

<style lang="scss">
</style>
